import { BankInfo } from '@/modules/employer/components/SetupEmployer/SetupEmployer.types';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  viewModalVisible: boolean;
  editModalVisible: boolean;
  addModalVisible: boolean;
  currentBank: BankInfo | null | undefined;

  setViewModalVisible: (value: boolean) => void;
  setEditModalVisible: (value: boolean) => void;
  setAddModalVisible: (value: boolean) => void;
  setCurrentBank: (bank: BankInfo | null | undefined) => void;
  handleReset: () => void;
}

export const useEmployerReactivationBankListModalsStore = storeCreator<State>((set) => ({
  viewModalVisible: false,
  editModalVisible: false,
  addModalVisible: false,
  currentBank: null,

  setViewModalVisible: (value) => set((state) => ({ ...state, viewModalVisible: value })),
  setEditModalVisible: (value) => set((state) => ({ ...state, editModalVisible: value })),
  setAddModalVisible: (value) => set((state) => ({ ...state, addModalVisible: value })),
  setCurrentBank: (bank) => set((state) => ({ ...state, currentBank: bank })),
  handleReset: () => set((state) => ({
    ...state,
    viewModalVisible: false,
    editModalVisible: false,
    addModalVisible: false,
    currentBank: null,
  })),
}));
